import type {
  CourseInformation,
  CourseOtherDetailWithMember,
  CourseStatus
} from '@/models/interface/newCourse';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';

export class NewCourseService extends ApiFactory {
  constructor() {
    super('NewCourse');
  }

  /**
   * 取得課程資訊
   * @param classId
   * @returns
   */
  getCourseInformation(classId: string): Promise<ApiDataResponse<CourseInformation>> {
    return this.get(`GetCourseInformation/${classId}`);
  }

  /**
   * 取得課程與學員狀態
   * @param classId
   * @returns
   */
  getCourseStatus(classId: string): Promise<ApiDataResponse<CourseStatus>> {
    return this.get(`GetCourseStatus/${classId}`, undefined, {
      headers: {
        disableGlobalLoading: true
      }
    });
  }

  /**
   * 取得受學員身分影響的其他資訊
   * @param classId
   * @returns
   */
  getCourseOtherDetailWithMember(
    classId: string
  ): Promise<ApiDataResponse<CourseOtherDetailWithMember>> {
    return this.get(`GetCourseOtherDetailWithMember/${classId}`);
  }
}
